(function () {
  // Smooth round-trip Add to Cart confirm animation.
  // Click → button briefly flashes green → settles back to coral.
  // All driven by a single CSS keyframe animation. We just toggle the class.

  var ANIM_CLASS = 'is-cart-added';
  var ANIM_NAME = 'll-cart-confirm';

  function trigger(btn) {
    // Remove + force reflow + re-add so the animation restarts cleanly on repeat taps
    btn.classList.remove(ANIM_CLASS);
    // eslint-disable-next-line no-unused-expressions
    btn.offsetWidth;
    btn.classList.add(ANIM_CLASS);
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.product-form__submit');
      if (!btn) return;
      if (btn.getAttribute('aria-disabled') === 'true') return;
      trigger(btn);
    },
    true
  );

  // Auto-remove the class once the animation finishes — keeps the button
  // ready to fire again, and ensures the visual settles back to coral.
  document.addEventListener(
    'animationend',
    function (e) {
      if (e.animationName !== ANIM_NAME) return;
      var t = e.target;
      if (t && t.classList && t.classList.contains(ANIM_CLASS)) {
        t.classList.remove(ANIM_CLASS);
      }
    },
    true
  );
})();
